function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.414 16H14a1 1 0 010 2H5a1 1 0 01-1-1V8a1 1 0 112 0v6.586L16.293 4.293a1 1 0 011.414 1.414L7.414 16z"
});

var SvgArrowDownLeft = function SvgArrowDownLeft(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow-down-left.6c959317.svg";
export { SvgArrowDownLeft as ReactComponent };